import { setPassword } from "@api/auth/passwordReset/setPassword/api";
import { verify } from "@api/auth/passwordReset/verify/api";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse } from "@api";

import type { IPathBaseParam } from "./path";
import type { IPasswordResetDto, IPasswordResetResponse } from "./types";

const postApis = createPostApi<
  IApiResponse<IPasswordResetResponse>,
  IPathBaseParam,
  IPasswordResetDto
>("auth.passwordReset");

export const passwordReset = {
  ...postApis,
  setPassword,
  verify,
};
